<template>
  <div>
    <demandSelectForm
      v-for="n in seatCount.adult"
      :key="n"
      label="おとな"
      :options="[{ value: 'free', string: '無料' }]"
      :disabled="true"
    />

    <demandSelectForm
      v-for="n in seatCount.child"
      :key="n"
      label="こども"
      :options="[{ value: 'free', string: '無料' }]"
      :disabled="true"
    />

    <demandSelectForm
      v-for="n in seatCount.infant"
      :key="n"
      label="幼児"
      :options="[{ value: 'free', string: '無料' }]"
      :disabled="true"
    />
  </div>
</template>

<script>
import { useVModel } from "vue-composable";
export default {
  name: "TheDemandSelectPayment",
  props: {
    seatCount: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const seatCount = useVModel(props, "seatCount");
    return {
      seatCount,
    };
  },
};
</script>
